import { TitleCasePipe } from '@angular/common'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { GuardianInvite } from '@se-po/shared-data-access-models'
import { SeFeMenuOptions } from 'se-fe-menu'
import { PersonaGuardianInvite } from 'se-resource-types/lib/CentralService/Households'

@Component({
  selector: 'se-po-guardian-invite-info',
  templateUrl: './guardian-invite-info.component.html',
  styleUrls: ['./guardian-invite-info.component.scss'],
  providers: [TitleCasePipe]
})
export class GuardianInviteInfoComponent implements OnInit {
  @Input() public guardianToInvite: GuardianInvite | PersonaGuardianInvite

  @Output() public cancelInvite = new EventEmitter<string>()
  public primaryEmailDisplay: string
  public guardianName: string
  public access: string
  public moreMenuOptions: SeFeMenuOptions

  constructor(private titleCasePipe: TitleCasePipe) {}

  public ngOnInit(): void {
    this.primaryEmailDisplay = ('email' in this.guardianToInvite ? this.guardianToInvite?.email : this.guardianToInvite.email_address)
    this.guardianName = ''
    if('persona_id' in this.guardianToInvite) {
      this.guardianName = this.guardianToInvite.user?.self_persona.name
    }
    this.access = (this.titleCasePipe.transform(this.guardianToInvite?.access || '') + ' Access')
    this.createMenuOptions()
  }

  private createMenuOptions(): void {
    this.moreMenuOptions = {
      name: `moreMenu-${this.primaryEmailDisplay}`,
      sections: [
        {
          menuItems: [
            {
              text: 'Cancel',
              action: () => this.onCancelInvite(),
            },
          ],
        },
      ],
    }
  }


  private onCancelInvite(): void {
    //emit an Output event from cards that will then be handled by its parent components.
    this.cancelInvite.emit(this.primaryEmailDisplay)
  }
}
